var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("武林秘籍：九阴之98")]),_c('QuantJyJyPool',{attrs:{"quant_code":"9010","title":"九阴之九阳","zoom_start":"45"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }